import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule} from '@angular/material/grid-list';
import { MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatCardModule} from '@angular/material/card';
import { MatStepperModule} from '@angular/material/stepper';
import { MatExpansionModule} from '@angular/material/expansion';
import { MatBadgeModule} from '@angular/material/badge';
import { MatChipsModule} from '@angular/material/chips';
// import { NgApexchartsModule } from 'ng-apexcharts';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AgGridModule } from 'ag-grid-angular';
import { NavbarDashboardComponent } from '../components/common/navbar-dashboard/navbar-dashboard.component';
import { NavbarDashboardInstComponent } from '../modules/inst_dashboard/navbar-dashboard/navbar-dashboard.component';
import { NavbarOneDemoComponent } from '../modules/solfium_one_demo/components/navbar_one_demo/navbar_one_demo.component';
import { ChatComponent } from '../components/common/chat/chat.component';
import { CommonModule } from '@angular/common';
import { MaterialFileInputModule } from 'ngx-material-file-input';

@NgModule({
    declarations: [
        NavbarDashboardComponent,
        NavbarDashboardInstComponent,
        NavbarOneDemoComponent,
        ChatComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatProgressBarModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatTableModule,
        MatTooltipModule,
        MatTabsModule,
        MatDialogModule,
        MatGridListModule,
        MatCardModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatBadgeModule,
        MatChipsModule,
        MaterialFileInputModule,
        // NgApexchartsModule
        AgGridModule,
        MatNativeDateModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatProgressBarModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatTableModule,
        MatTooltipModule,
        MatTabsModule,
        MatDialogModule,
        MatGridListModule,
        MatSlideToggleModule,
        MatCardModule,
        MatStepperModule,
        MatExpansionModule,
        MatBadgeModule,
        MatChipsModule,
        MaterialFileInputModule,
        // NgApexchartsModule
        AgGridModule,
        NavbarDashboardComponent,
        NavbarDashboardInstComponent,
        NavbarOneDemoComponent,
        ChatComponent,
        MatNativeDateModule
    ]
})

export class SharedModule { }

export function httpTranslateLoader(http: HttpClient) {
    // return new TranslateHttpLoader(http, 'src/assets/i18n/', '.json');
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}